import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
// import Rx from 'rxjs/Rx';
import { AlertController, Events } from 'ionic-angular';
import { LanguageProvider } from '../language/language';
import { GlobalvariablesProvider } from '../globalvariables/globalvariables';
import { SettingsProvider } from '../settings/settings';

@Injectable()
export class InactiveProvider {
  returnVal;
  private timeoutID: any;
  public seconds: number = 0;
  private timer_is_on = false;
  public isInactive = false;
  private pageName = "";

  constructor(
    public http: Http, public alertCtrl: AlertController,
    public languageProvider: LanguageProvider,
    public events: Events,
    public global: GlobalvariablesProvider,
    public settingsProvider: SettingsProvider
  ) {

  }

  incrementCount() {
    if (!this.isInactive) {
      if (this.seconds >= this.global.idleTimeout) {
        this.stopCount();
        this.goInactive();
      }
      else {
        this.seconds = this.seconds + 1;
        //
        this.timeoutID = setTimeout(() => { this.incrementCount(); }, 1000);
      }
    }
  }

  startCount() {
    if (!this.timer_is_on) {
      this.timer_is_on = true;
      this.incrementCount();
    } else {
      this.resetCount("WebLoginPage");
    }
  }

  resetCount(pagename) {
    clearTimeout(this.timeoutID);
    this.seconds = 0;
    this.isInactive = false;
    this.timer_is_on = false;
    this.startCount();

    clearTimeout(this.timeoutID);
    this.seconds = 0;
    this.timer_is_on = false;
    this.pageName = pagename;
    //

    if (this.pageName !== "" && this.getPageName(pagename)) {
      if (this.pageName !== "WebLoginPage" && this.getPageName(pagename)) {
        this.startCount();
      }
    }
  }

  stopCount() {
    //
    clearTimeout(this.timeoutID);
    this.timer_is_on = false;
  }

  goInactive() {
    let self = this;
    //
    const dummychatbutton = document.getElementById('dummychatbutton');
    dummychatbutton.style.display = "none";
    if (document.getElementById("consectus_iframechat")) {
      document.getElementById("consectus_iframechat").style.display = "none";
    }
    this.isInactive = true;
    let alert = self.alertCtrl.create({
      title: "Timeout Warning",
      message: self.languageProvider.get("Due to inactivity, you have been logged out of your account for security reasons"),
      cssClass: 'timeout-alertDanger',
      buttons: [
        {
          text: self.languageProvider.get("Logout"),
          role: 'cancel',
          handler: () => {
            this.isInactive = false;
            let ss = self.settingsProvider.settings;
            ss.manually_logout = false;
            ss.timer_logout = true;
            self.settingsProvider.setSettings(ss).then(() => {
              self.remove();
              self.events.publish("consectus:loginform");
            });
            //this.events.publish("consectus:loginform");
          }
        },
      ], enableBackdropDismiss: false
    });
    alert.present();
    // this.logout();
  }

  getSeconds() {
    return this.seconds;
  }

  getPageName(pageName) {
    this.returnVal = true;
    switch (pageName) {
      case "MobileVerificationPage":
        this.returnVal = false
        break;
      case "OtpPage":
        this.returnVal = false;
        break;
      case "NewMemberVerificationPage":
        this.returnVal = false;
        break;
      case "ExistingCustomerVerificationPage":
        this.returnVal = false;
        break;
      case "SetPinPage":
        this.returnVal = false;
        break;
      case "AgreeTermsConditionsPage":
        this.returnVal = false;
        break;
      case "ExistingPinPage":
        this.returnVal = false;
        break;
      case "HintPage":
        this.returnVal = false;
        break;
      case "OnboardingMailerPage":
        this.returnVal = false;
        break;
      case "SplashPage":
        this.returnVal = false;
        break;
      case "WelcomePage":
        this.returnVal = false;
        break;
      case "RegisterPage":
        this.returnVal = false;
        break;
      case "CodeAcceptedPage":
        this.returnVal = false;
        break;
      case "AccountProcessingPage":
        this.returnVal = false;
        break;
      case "HoldingScreenPage":
        this.returnVal = false;
        break;
      case "OpenAccountPage":
        this.returnVal = false;
        break;
      case "PayFundPage":
        this.returnVal = false;
        break;
      case "PayFundsToAccountsPage":
        this.returnVal = false;
        break;
      case "ProductFormPage":
        this.returnVal = false;
        break;
      case "ScreenMessagePage":
        this.returnVal = false;
        break;
      case "UniqueReferencePage":
        this.returnVal = false;
        break;
      case "WelcomePackPage":
        this.returnVal = false;
        break;
      case "VerifyPinPage":
        this.returnVal = false;
        break;
      case "ResetPinPage":
        this.returnVal = false;
        break;
      case "NeedHelp":
        this.returnVal = false;
        break;
      case "FaqCategoryPage":
        this.returnVal = false;
        break;
      case "ExistingCustomerDetailsPage":
        this.returnVal = false;
        break;
      case "TaxResidencyPage":
        this.returnVal = false;
        break;
      case "ProductTermsConditionsPage":
        this.returnVal = false;
        break;
      case "ThankYouApplyPage":
        this.returnVal = false;
        break;
      case "ActiveThankPage":
        this.returnVal = false;
        break;
    }
    return this.returnVal;
  }
  remove() {
    let scriptElement = document.getElementById("consectus_iframechat");
    if (scriptElement) {
      scriptElement.remove();
      console.log("Script removed.");
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/inactive/inactive.ts